import { pxToRem, theme } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const Container = styled.div `
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.sm};
  width: 100%;
  padding: ${theme.spacing.md};
  border-radius: ${theme.borderRadius.md};
  border: solid ${pxToRem(1)} ${theme.semantic.border.default};
`;
export const ToggleButtonContainer = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${theme.spacing.sm};
  border-radius: ${theme.borderRadius.md};
  transition: background-color 150ms ease-in-out;

  &:hover {
    cursor: pointer;
    background-color: ${theme.semantic.surface.sunken};
  }
`;
export const FileList = styled.ul `
  display: ${(props) => (props.$show ? 'flex' : 'none')};
  flex-direction: column;
  gap: ${theme.spacing.sm};
`;
export const File = styled.li `
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${theme.spacing.sm};
`;
